import React, { useRef, useEffect, useState } from 'react';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import { useTheme } from '../../context/ThemeContext';

export default function EmojiPicker({ onSelect, onClose, triggerRef }) {
    const { theme } = useTheme();
    const pickerRef = useRef(null);
    const [position, setPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
        // Position relative to the trigger button or fallback to center
        if (triggerRef?.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            const pickerWidth = 352;
            const pickerHeight = 435;

            let top = rect.top - pickerHeight - 8;
            let left = rect.left - pickerWidth / 2 + rect.width / 2;

            // Keep within viewport
            if (top < 8) top = rect.bottom + 8;
            if (left < 8) left = 8;
            if (left + pickerWidth > window.innerWidth - 8) {
                left = window.innerWidth - pickerWidth - 8;
            }

            setPosition({ top, left });
        }
    }, [triggerRef]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (pickerRef.current && !pickerRef.current.contains(e.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    return (
        <div
            ref={pickerRef}
            className="fixed z-50"
            style={{ top: position.top, left: position.left }}
        >
            <Picker
                data={data}
                onEmojiSelect={(emoji) => {
                    onSelect(emoji.native);
                    onClose();
                }}
                theme={theme === 'dark' ? 'dark' : 'light'}
                previewPosition="none"
                skinTonePosition="none"
                maxFrequentRows={2}
            />
        </div>
    );
}
